import DesignHubAPICall from "src/service/DesignHubAPICall";

class DesignHubRepository {
    registerUser = async (params) => {
        return await new DesignHubAPICall().registerUser(params);
    };
}

export default DesignHubRepository;